import { render, staticRenderFns } from "./smallcard.vue?vue&type=template&id=735d37a6&"
import script from "./smallcard.vue?vue&type=script&lang=js&"
export * from "./smallcard.vue?vue&type=script&lang=js&"
import style0 from "./smallcard.vue?vue&type=style&index=0&id=735d37a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports